import {
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonPage,
} from '@ionic/react';
import { add } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Can } from '../../api/authorization.provider';
import { BookmarkType } from '../../api/hooks/bookmark.hooks';
import { PageHeader } from '../../components/header/page.header';
import { TeamList } from '../../components/team/team-list';
import { useBeaconRouter } from '../../route/route.hooks';

const TeamListPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <PageHeader
        title={i18n.t('common:teams')}
        bookmarkProps={{ enable: true, type: BookmarkType.TEAM }}
      />
      <IonContent>
        <TeamList />
        <Can I="create" a="team">
          <IonFab vertical="bottom" horizontal="end" slot="fixed">
            <IonFabButton routerLink={builder.getNewTeamRoute()}>
              <IonIcon icon={add} />
            </IonFabButton>
          </IonFab>
        </Can>
      </IonContent>
    </IonPage>
  );
};

export { TeamListPage };
